module.exports = __webpack_public_path__ + "static/img/1.1025ec85.png";